import { Input } from '../components/forms/Input';
import { Textarea } from '../components/forms/Textarea';
import { Switch } from '../components/forms/Switch';
import { Checkbox } from '../components/forms/Checkbox';
import { Select } from '../components/forms/select';
import { DateTimePicker } from '../components/forms/DateTimePicker';
import { CurrencyInput } from '../components/forms/CurrencyInput';
import { ColorPicker } from '../components/forms/ColorPicker';
import { FileUpload } from '../components/forms/FileUpload';
import { Slider } from '../components/forms/Slider';

/**
 * @group Types
 * 
 * @summary
 * <blockquote>Registry mapping field types to their corresponding components.</blockquote>
 * 
 * @example
 * ```typescript
 * import { fieldRegistry } from '@shared/ui'
 * 
 * const Component = fieldRegistry['text']; // Returns Input component
 * ```
 */
export const fieldRegistry: Record<string, React.ComponentType<any>> = {
  text: Input,
  email: Input,
  password: Input,
  url: Input,
  number: Input,
  textarea: Textarea,
  switch: Switch,
  checkbox: Checkbox,
  select: Select,
  date: DateTimePicker,
  datetime: DateTimePicker,
  currency: CurrencyInput,
  color: ColorPicker,
  file: FileUpload,
  slider: Slider,
}; 